import sapiConfig from "../configs/sapi";
import { invoiceDNDetailModel, pmxDetailModel, pmxOverviewModel, usageL36M2Model, usageL36M2V2Model, valueL36MModel } from "../models/reportsModel";
import { actionTypesReports } from "../redux/constants/actionTypesReports";
import { ReportsDispatcher } from "../redux/dispatcher/reportsDispatcher";
import { httpMStepsClient } from "./utils/httpService";
import { logError } from "./utils/logService";
import { sortCollection } from "../utils/sortCollection";

import * as Sentry from "@sentry/browser";

//BASE_URL
const BASE_URL = sapiConfig.api.domain;

const getLocation = (location: string) => {
  return location.replace("Australia/", "");
};

export const getPmxInventory = async (
  searchText: string,
  team: string,
  location: string,
  tableHeaders: Record<string, Record<string, string | number | boolean>>
) => {
  let pmxResult: Array<pmxOverviewModel> = [];
  const methodPath = `/report/pmx_inventory_report?${getLocation(
    location
  )}&${team.toLowerCase()}&${searchText}`;

  await httpMStepsClient({
    baseURL: BASE_URL,
    type: "GET",
    path: methodPath,
  })
    .then((result) => {
      pmxResult = sortCollection(
        tableHeaders,
        "sortDirection",
        result.data.recordset
      ) as Array<pmxOverviewModel>;
    })
    .catch((error) => {
      logError(error);
      Sentry.captureException(error);
    });

  ReportsDispatcher(actionTypesReports.ListOfPmxInventory, pmxResult);
};

export const getPmxDetailsInventory = async (
  searchText: string,
  team: string,
  location: string,
  tableHeaders: Record<string, Record<string, string | number | boolean>>
) => {
  let pmxDetailResult: Array<pmxDetailModel> = [];
  const methodPath = `/report/pmx_details_inventory_report?${getLocation(
    location
  )}&${team.toLowerCase()}&${searchText}`;

  await httpMStepsClient({
    baseURL: BASE_URL,
    type: "GET",
    path: methodPath,
  })
    .then((result) => {
      pmxDetailResult = sortCollection(
        tableHeaders,
        "sortDirection",
        result.data.recordset
      ) as Array<pmxDetailModel>;
    })
    .catch((error) => {
      logError(error);
      Sentry.captureException(error);
    });

  ReportsDispatcher(
    actionTypesReports.ListOfPmxInventoryDetail,
    pmxDetailResult
  );
};

// #UsageL36M2 No app-level guard — no check against isUsageL36M2ReportListLoaded; always calls API on every invocation
export const getUsageL36M2 = async () => {
  let result: Array<usageL36M2Model> = [];

  await httpMStepsClient({
    baseURL: BASE_URL,
    type: "GET",
    path: "/report/usage_l36m2_3y",
  })
    .then((res) => {
      result = res.data.recordset ?? [];
    })
    .catch((error) => {
      logError(error);
      Sentry.captureException(error);
    });

  ReportsDispatcher(actionTypesReports.ListOfUsageL36M2, result);
};

// #UsageL36M2V2 No app-level guard — no check against isUsageL36M2V2ReportListLoaded; always calls API on every invocation
export const getUsageL36M2V2 = async () => {
  let result: Array<usageL36M2V2Model> = [];

  await httpMStepsClient({
    baseURL: BASE_URL,
    type: "GET",
    path: "/report/usage_l36m2_v2",
  })
    .then((res) => {
      result = res.data.recordset ?? [];
    })
    .catch((error) => {
      logError(error);
      Sentry.captureException(error);
    });

  ReportsDispatcher(actionTypesReports.ListOfUsageL36M2V2, result);
};

export const getValueL36M = async () => {
  let result: Array<valueL36MModel> = [];

  await httpMStepsClient({
    baseURL: BASE_URL,
    type: "GET",
    path: "/report/value_l36m",
  })
    .then((res) => {
      result = res.data.recordset ?? [];
    })
    .catch((error) => {
      logError(error);
      Sentry.captureException(error);
    });

  ReportsDispatcher(actionTypesReports.ListOfValueL36M, result);
};

export const getInvoiceDNDetail = async () => {
  let result: Array<invoiceDNDetailModel> = [];

  await httpMStepsClient({
    baseURL: BASE_URL,
    type: "GET",
    path: "/report/invoice_dn_detail",
  })
    .then((res) => {
      result = res.data.recordset ?? [];
    })
    .catch((error) => {
      logError(error);
      Sentry.captureException(error);
    });

  ReportsDispatcher(actionTypesReports.ListOfInvoiceDNDetail, result);
};
